// ============================================
// COUNTDOWN TIMER - Alpine.js Component
// ============================================

export function registerCountdownTimer(): void {
    (window as any).countdownTimer = function (expiryDate: string | Date) {
        return {
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
            interval: null as number | null,
            is_ended:false,

            init() {
                this.updateCountdown();
                this.interval = window.setInterval(() => {
                    this.updateCountdown();
                }, 1000);
            },

            padZero(num: number): string {
                return num.toString().padStart(2, '0');
            },

            updateCountdown() {
                const now = new Date().getTime();
                const expiry = new Date(expiryDate).getTime();
                const distance = expiry - now;

                if (distance < 0) {
                    this.days = '00';
                    this.hours = '00';
                    this.minutes = '00';
                    this.seconds = '00';
                    if (this.interval) {
                        clearInterval(this.interval);
                        this.interval = null;
                    }
                    this.is_ended = true;
                    return;
                }

                const daysNum = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hoursNum = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutesNum = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const secondsNum = Math.floor((distance % (1000 * 60)) / 1000);

                this.days = this.padZero(daysNum);
                this.hours = this.padZero(hoursNum);
                this.minutes = this.padZero(minutesNum);
                this.seconds = this.padZero(secondsNum);
            },

            destroy() {
                if (this.interval) {
                    clearInterval(this.interval);
                    this.interval = null;
                }
            }
        };
    };
}
